import React from 'react';
import { fieldNames } from '../../../common/config';
import { Form } from 'antd';
import DropdownSelect from '../../../../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';
import { useShutdownTypes } from '../../../../../shared/api/queries/shutdownTypes';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';

const typeFieldName = fieldNames.type;
const FormItem = Form.Item;

const TypeField = ({ form }) => {
  const { data = [], isFetching } = useShutdownTypes({ staleTime: Infinity });

  const options = getOptionsBySelect(data);

  return (
    <FormItem
      label="Тип"
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(typeFieldName, {
        rules: [
          {
            required: true,
            message: 'Укажите тип',
          },
        ],
      })(
        <DropdownSelect
          multiple={false}
          options={options}
          renderControl={getRenderControl({
            options: options,
            isClear: false,
            value: form.getFieldValue(typeFieldName),
            disabled: isFetching,
            loading: isFetching,
          })}
        />
      )}
    </FormItem>
  );
};

export default TypeField;
